import { Col, Row } from "antd";
import { useBannerContext } from "../../../context/BannerContext/BannerContext";
import SwitchOptionComponent from "../../../components/SwitchComponent";

const BannerInfo = () => {
	const { bannerForm, setBannerForm } = useBannerContext();

	return (
		<>
			<Row gutter={20}>
				<Col span={8}>
					<SwitchOptionComponent
						key={"isActive"}
						title={"Aktiflik"}
						onChange={(checked) => setBannerForm({ ...bannerForm, isActive: checked })}
					/>
				</Col>
				<Col span={8}>
					<SwitchOptionComponent
						key={"hasNavigation"}
						title={"Yönlendirme"}
						helperText={"Banner'a tıklandığında yönlendirme yapılmasını sağlar."}
						onChange={(checked) => setBannerForm({ ...bannerForm, hasNavigation: checked })}
					/>
				</Col>
			</Row >
		</>
	);
};

export default BannerInfo;
